const createIsoDate = (date) => {
  const timeZoneOffset = new Date().getTimezoneOffset() * 60000;
  const localISOTime = new Date(date - timeZoneOffset).toISOString();
  return localISOTime;
};

export default createIsoDate;
